import { css } from 'lit';
export default css `
  :host {
    display: block;
    position: absolute;
    opacity: 0;
    pointer-events: none;
    top: 11px;
    left: 50%;
    width: max-content;
  }
`;
//# sourceMappingURL=styles.js.map